module.exports = __webpack_public_path__ + "static/media/GridLayout.56e4a001.svg";